/**
 * Baby Name results list: URL-driven generator results + saved-name integration.
 */
(function (root, factory) {
  var api = factory(root);

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.MomcozyBabyNameList = api;
    api.boot(root.document);
  }
})(typeof window !== 'undefined' ? window : null, function (browserRoot) {
  var MOBILE_BREAKPOINT = 768;
  var RESULTS_PAGE_SIZE = 15;
  var RANK_BAR_BASE = 1000;
  var RANK_BAR_MIN_PCT = 6;
  var DEFAULT_RANK_YEAR = 2025;
  var MAX_PAGES = 100;
  var DEFAULT_LABELS = {
    resultsTitleDefault:
      '[[count]] baby [[noun]] that should work for you and your baby',
    resultsTitleGender:
      '[[count]] [[gender]] baby [[noun]] that should work for you and your baby',
    resultsTitleSurname:
      '[[count]] baby [[noun]] that [[pair_verb]] with \u201C[[surname]]\u201D',
    resultsTitleGenderSurname:
      '[[count]] [[gender]] [[noun]] that [[pair_verb]] with \u201C[[surname]]\u201D',
    nounSingular: 'name',
    nounPlural: 'names',
    pairVerbSingular: 'pairs',
    pairVerbPlural: 'pair',
    genderGirl: 'girl',
    genderBoy: 'boy',
    emptyMessage: 'No names match those filters. Try removing a filter.',
    retryLabel: 'Retry',
    msgLoadError: 'We could not load names. Please try again.',
    msgSessionExpired: 'Your session has expired. Please log in again.',
    msgShortlistFull:
      'Your Shortlist is full. Remove a name before adding another.',
    msgShortlistUnavailable: 'Shortlist is temporarily unavailable.',
    msgSaveError: 'We could not save that name. Please try again.',
    msgRemoveError: 'We could not remove that name. Please try again.',
    msgSavedToast: '[[name]] is saved to your baby names list.',
    msgRemovedToast: '[[name]] is removed from your list.',
    ariaSaveTo: 'Save [[name]] to Shortlist',
    ariaRemoveFrom: 'Remove [[name]] from Shortlist',
    ariaPage: 'Go to page [[page]]',
    ariaPrevPage: 'Previous page',
    ariaNextPage: 'Next page',
    rankInYear: '#[[rank]] in [[year]]',
    shortlistError: 'We could not load your shortlist. Please try again.'
  };

  function applyLabelTemplate(template, vars) {
    var output = String(template == null ? '' : template);
    vars = vars || {};
    Object.keys(vars).forEach(function (key) {
      output = output.split('[[' + key + ']]').join(String(vars[key]));
    });
    return output;
  }

  function mergeLabels(overrides) {
    var labels = Object.assign({}, DEFAULT_LABELS);
    if (!overrides || typeof overrides !== 'object') return labels;
    Object.keys(overrides).forEach(function (key) {
      if (
        overrides[key] !== undefined &&
        overrides[key] !== null &&
        overrides[key] !== ''
      ) {
        labels[key] = overrides[key];
      }
    });
    return labels;
  }

  function parseLabelsFromRoot(root) {
    if (!root || !root.querySelector) return mergeLabels();
    var node = root.querySelector('[data-baby-name-list-labels]');
    if (!node) return mergeLabels();
    try {
      return mergeLabels(JSON.parse(node.textContent || '{}'));
    } catch (error) {
      return mergeLabels();
    }
  }
  var NAME_ROWS = [
    [
      'Olivia',
      'Amelia',
      'Emma',
      'Sophia',
      'Charlotte',
      'Isabella',
      'Ava',
      'Mia',
      'Evelyn',
      'Luna'
    ],
    [
      'Harper',
      'Camila',
      'Sofia',
      'Scarlett',
      'Elizabeth',
      'Eleanor',
      'Emily',
      'Chloe',
      'Mila',
      'Violet'
    ],
    [
      'Penelope',
      'Gianna',
      'Aria',
      'Abigail',
      'Ella',
      'Avery',
      'Hazel',
      'Nora',
      'Layla',
      'Lily'
    ],
    [
      'Aurora',
      'Nova',
      'Ellie',
      'Madison',
      'Grace',
      'Isla',
      'Willow',
      'Zoe',
      'Riley',
      'Stella'
    ],
    [
      'Eliana',
      'Ivy',
      'Victoria',
      'Emilia',
      'Zoey',
      'Naomi',
      'Hannah',
      'Lucy',
      'Elena',
      'Lillian'
    ],
    [
      'Maya',
      'Leah',
      'Paisley',
      'Addison',
      'Natalie',
      'Valentina',
      'Everly',
      'Delilah',
      'Leilani',
      'Madelyn'
    ],
    [
      'Kinsley',
      'Ruby',
      'Sophie',
      'Alice',
      'Genesis',
      'Claire',
      'Audrey',
      'Sadie',
      'Aaliyah',
      'Josephine'
    ],
    [
      'Autumn',
      'Brooklyn',
      'Quinn',
      'Kennedy',
      'Cora',
      'Savannah',
      'Caroline',
      'Athena',
      'Natalia',
      'Hailey'
    ],
    [
      'Aubrey',
      'Emery',
      'Anna',
      'Iris',
      'Bella',
      'Eloise',
      'Skylar',
      'Jade',
      'Gabriella',
      'Ariana'
    ],
    [
      'Maria',
      'Adeline',
      'Lydia',
      'Sarah',
      'Nevaeh',
      'Serenity',
      'Liliana',
      'Ayla',
      'Everleigh',
      'Raelynn'
    ],
    [
      'Allison',
      'Eva',
      'Madeline',
      'Piper',
      'Rylee',
      'Faith',
      'Vivian',
      'Samantha',
      'Rose',
      'Margaret'
    ],
    [
      'Melody',
      'Julia',
      'Juniper',
      'Arya',
      'Eden',
      'Eliza',
      'Adalynn',
      'Kaylee',
      'Lyla',
      'Maeve'
    ]
  ];
  var MEANINGS = [
    'Olive tree',
    'Industrious and striving',
    'Whole and universal',
    'Wisdom',
    'Free and strong',
    'Devoted to God',
    'Life and voice',
    'Beloved',
    'Wished-for child',
    'Moonlight'
  ];
  var ORIGINS = [
    'Latin',
    'German',
    'English',
    'Greek',
    'French',
    'Hebrew',
    'Italian',
    'Spanish',
    'Irish',
    'Arabic'
  ];

  function slugify(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function createMockNames() {
    return NAME_ROWS.reduce(function (items, row) {
      return items.concat(row);
    }, []).map(function (firstName, index) {
      var rank = index + 1;
      return {
        id: 'mock-baby-name-' + rank,
        first_name: firstName,
        gender: rank % 17 === 0 ? 'boy' : 'girl',
        meanings: [MEANINGS[index % MEANINGS.length]],
        origin: ORIGINS[index % ORIGINS.length],
        rank: rank,
        year: 2026,
        popularity: Math.max(8, Math.round(100 - index * 0.72)),
        trend:
          rank % 11 === 0 || rank === 5
            ? 'rising'
            : rank % 13 === 0
              ? 'falling'
              : 'stable',
        location: '/blogs/baby-names/' + slugify(firstName)
      };
    });
  }

  function getPageSize(viewportWidth) {
    return Number(viewportWidth) < MOBILE_BREAKPOINT ? 10 : 15;
  }

  function normalizePopularity(value) {
    if (
      value === '' ||
      value === null ||
      typeof value === 'undefined' ||
      value === 'all'
    )
      return null;
    var parsed = Number(value);
    return Number.isFinite(parsed) && parsed !== 0 ? parsed : null;
  }

  function toApiGender(value) {
    if (value === 'girl') return 'F';
    if (value === 'boy') return 'M';
    return null;
  }

  function fromApiGender(value) {
    var normalized = String(value || '').toUpperCase();
    if (normalized === 'F') return 'girl';
    if (normalized === 'M') return 'boy';
    return '';
  }

  /**
   * Normalize gender for shortlist matching.
   * API saved-names may use F/M; result cards use girl/boy.
   */
  function normalizeGenderKey(value) {
    var fromApi = fromApiGender(value);
    if (fromApi) return fromApi;
    var normalized = String(value || '')
      .trim()
      .toLowerCase();
    if (normalized === 'girl' || normalized === 'boy') return normalized;
    return '';
  }

  function buildResultsPayload(route) {
    route = route || {};
    var filter = {};
    var gender = toApiGender(route.gender);
    if (gender) filter.gender = gender;
    [
      'surname',
      'starting',
      'ending',
      'syllables',
      'meanings',
      'theme',
      'origin'
    ].forEach(function (key) {
      if (
        route[key] !== '' &&
        route[key] !== null &&
        typeof route[key] !== 'undefined'
      )
        filter[key] = route[key];
    });
    var popularity = normalizePopularity(route.popularity);
    if (popularity !== null) filter.popularity = popularity;
    return {
      filter: filter,
      sorting:
        route.sort === 'name' || route.sort === '-name' ? route.sort : null,
      page: Math.min(100, Math.max(1, Number(route.page) || 1)),
      pagesize: RESULTS_PAGE_SIZE
    };
  }

  function rankToBarPercent(rank) {
    var value = Number(rank);
    if (!Number.isFinite(value) || value < 1) return RANK_BAR_MIN_PCT;
    var pct = ((RANK_BAR_BASE - value + 1) / RANK_BAR_BASE) * 100;
    return Math.max(RANK_BAR_MIN_PCT, Math.min(100, pct));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /**
   * Figma title: `{count} girl names that pair with “Carter”`
   * Count is rendered bold + brand color via buildResultsTitleHtml.
   * Templates use [[count]] [[gender]] [[noun]] [[pair_verb]] [[surname]].
   */
  function buildResultsTitle(total, route, labels) {
    labels = mergeLabels(labels);
    var count = Math.max(0, Number(total) || 0);
    route = route || {};
    var genderKey =
      route.gender === 'girl' || route.gender === 'boy' ? route.gender : '';
    var gender = genderKey
      ? genderKey === 'boy'
        ? labels.genderBoy
        : labels.genderGirl
      : '';
    var surname = String(route.surname || '').trim();
    var vars = {
      count: count,
      gender: gender,
      noun: count === 1 ? labels.nounSingular : labels.nounPlural,
      pair_verb: count === 1 ? labels.pairVerbSingular : labels.pairVerbPlural,
      surname: surname
    };

    if (surname) {
      if (genderKey) {
        return applyLabelTemplate(labels.resultsTitleGenderSurname, vars);
      }
      return applyLabelTemplate(labels.resultsTitleSurname, vars);
    }

    if (genderKey) {
      return applyLabelTemplate(labels.resultsTitleGender, vars);
    }

    return applyLabelTemplate(labels.resultsTitleDefault, vars);
  }

  function buildResultsTitleHtml(total, route, labels) {
    var count = Math.max(0, Number(total) || 0);
    var plain = buildResultsTitle(total, route, labels);
    var prefix = String(count);
    if (plain.indexOf(prefix) !== 0) return escapeHtml(plain);
    return (
      '<span class="yg-bn-list__title-count">' +
      prefix +
      '</span>' +
      escapeHtml(plain.slice(prefix.length))
    );
  }

  function normalizeResultName(name, fallbackGender) {
    name = name || {};
    var firstName = String(name.name || '').trim();
    if (!firstName) {
      throw new Error('Generator response is missing required card fields');
    }
    var gender = fromApiGender(name.gender) || fromApiGender(fallbackGender);
    var rankValue = Number(name.ranks);
    var hasRank =
      name.ranks !== null &&
      name.ranks !== undefined &&
      String(name.ranks).trim() !== '' &&
      Number.isFinite(rankValue);
    var popularity = Number(name.popularity);
    var meanings = Array.isArray(name.meanings)
      ? name.meanings
          .map(function (meaning) {
            return String((meaning && meaning.keyword) || '').trim();
          })
          .filter(Boolean)
          .slice(0, 2)
      : [];
    var categories = Array.isArray(name.categories)
      ? name.categories
          .map(function (category) {
            return String(category || '').trim();
          })
          .filter(Boolean)
      : [];
    var hasYear =
      name.year !== null &&
      name.year !== undefined &&
      String(name.year).trim() !== '';
    var year = hasYear ? name.year : '';
    var hasPopularity =
      name.popularity !== null &&
      name.popularity !== undefined &&
      Number.isFinite(popularity) &&
      popularity >= 0 &&
      popularity <= 100;
    var validTrend =
      name.trend === 'rising' ||
      name.trend === 'falling' ||
      name.trend === 'stable';
    var location =
      typeof name.location === 'string' ? name.location.trim() : '';

    return {
      id: name.id || slugify(firstName) + '-' + (gender || 'any'),
      first_name: firstName,
      gender: gender,
      meanings: meanings,
      categories: categories,
      origin:
        name.origins === null || name.origins === undefined
          ? ''
          : String(name.origins),
      rank: hasRank ? rankValue : null,
      year: year,
      popularity: hasPopularity ? popularity : null,
      trend: validTrend ? name.trend : '',
      location: location
    };
  }

  function getCardPresentation(name, labels) {
    labels = mergeLabels(labels);
    name = name || {};
    var meanings = Array.isArray(name.meanings)
      ? name.meanings.filter(Boolean).slice(0, 2)
      : [];
    // Treat null/undefined/'' as missing — Number(null) is 0 and would fake a rank.
    var hasRank =
      name.rank !== null &&
      name.rank !== undefined &&
      String(name.rank).trim() !== '' &&
      Number.isFinite(Number(name.rank));
    var rank = hasRank ? Number(name.rank) : NaN;
    var year =
      name.year !== null &&
      name.year !== undefined &&
      String(name.year).trim() !== ''
        ? name.year
        : DEFAULT_RANK_YEAR;
    return {
      genderLabel: name.gender ? String(name.gender).toUpperCase() : '',
      meaningLabel: meanings.length ? '“' + meanings.join('” · “') + '”' : '',
      originLabel: name.origin ? '“' + name.origin + '”' : '',
      rankLabel: hasRank
        ? applyLabelTemplate(labels.rankInYear, {
            rank: rank,
            year: year
          })
        : '',
      popularity: hasRank ? rankToBarPercent(rank) : null,
      trendLabel: ''
    };
  }

  function normalizeResultsResponse(response, payload) {
    if (!response || (response.result && response.result !== 'success'))
      throw new Error('Generator request failed');
    var data = response.data || response;
    if (!data || !Array.isArray(data.baby_names))
      throw new Error('Generator response is invalid');
    var page = Math.min(
      MAX_PAGES,
      Math.max(1, Number(payload && payload.page) || 1)
    );
    var pagesize = Math.max(
      1,
      Number(payload && payload.pagesize) || RESULTS_PAGE_SIZE
    );
    var fallbackGender = payload && payload.filter && payload.filter.gender;
    var names = [];
    data.baby_names.forEach(function (name) {
      try {
        names.push(normalizeResultName(name, fallbackGender));
      } catch (error) {
        // Isolate invalid rows so one bad record cannot fail the whole page.
      }
    });
    var hasNext = names.length === pagesize && page < MAX_PAGES;
    var totalFromApi = Number(data.total);
    var total = Number.isFinite(totalFromApi)
      ? Math.max(0, totalFromApi)
      : hasNext
        ? page * pagesize + 1
        : (page - 1) * pagesize + names.length;
    return {
      page: page,
      pagesize: pagesize,
      total: total,
      hasNext: hasNext,
      names: names
    };
  }

  function queryMockNames(names, params) {
    params = params || {};
    var filtered = (names || []).slice();
    var popularity = normalizePopularity(
      params.filter && params.filter.popularity
    );

    if (popularity > 0)
      filtered = filtered.filter(function (name) {
        return Number(name.rank) <= popularity;
      });
    if (popularity < 0)
      filtered = filtered.filter(function (name) {
        return Number(name.rank) > Math.abs(popularity);
      });

    if (params.sorting === 'name') {
      filtered.sort(function (a, b) {
        return a.first_name.localeCompare(b.first_name);
      });
    } else if (params.sorting === '-name') {
      filtered.sort(function (a, b) {
        return b.first_name.localeCompare(a.first_name);
      });
    } else {
      filtered.sort(function (a, b) {
        return Number(a.rank) - Number(b.rank);
      });
    }

    var pageSize = Math.max(1, Number(params.pagesize) || RESULTS_PAGE_SIZE);
    var pages = Math.max(1, Math.ceil(filtered.length / pageSize));
    var page = Math.min(pages, Math.max(1, Number(params.page) || 1));
    var start = (page - 1) * pageSize;

    return Promise.resolve({
      result: 'success',
      data: {
        total: filtered.length,
        data: filtered.slice(start, start + pageSize),
        page: page,
        pagesize: pageSize
      }
    });
  }

  function getPagerState(currentPage, total, pageSize) {
    var size = Math.max(1, Number(pageSize) || RESULTS_PAGE_SIZE);
    var totalCount = Math.max(0, Number(total) || 0);
    var totalPages = Math.min(
      MAX_PAGES,
      Math.max(totalCount > 0 ? 1 : 0, Math.ceil(totalCount / size))
    );
    var page = Math.min(
      Math.max(1, totalPages || 1),
      Math.max(1, Number(currentPage) || 1)
    );
    if (totalPages > 0) page = Math.min(page, totalPages);

    var items = [];
    if (totalPages <= 1) {
      // no numbered items when a single page or empty
    } else if (totalPages <= 4) {
      for (var i = 1; i <= totalPages; i++)
        items.push({ type: 'page', page: i });
    } else if (page <= 3) {
      items.push({ type: 'page', page: 1 });
      items.push({ type: 'page', page: 2 });
      items.push({ type: 'page', page: 3 });
      if (totalPages > 5) {
        items.push({ type: 'page', page: 4 });
        items.push({ type: 'ellipsis' });
      } else if (totalPages === 5) {
        items.push({ type: 'page', page: 4 });
      }
      items.push({ type: 'page', page: totalPages });
    } else if (page >= totalPages - 2) {
      items.push({ type: 'page', page: 1 });
      items.push({ type: 'ellipsis' });
      if (totalPages > 5) {
        items.push({ type: 'page', page: totalPages - 2 });
      }
      items.push({ type: 'page', page: totalPages - 1 });
      items.push({ type: 'page', page: totalPages });
    } else {
      items.push({ type: 'page', page: 1 });
      items.push({ type: 'ellipsis' });
      items.push({ type: 'page', page: page - 1 });
      items.push({ type: 'page', page: page });
      items.push({ type: 'page', page: page + 1 });
      items.push({ type: 'ellipsis' });
      items.push({ type: 'page', page: totalPages });
    }

    return {
      page: page,
      total: totalCount,
      totalPages: totalPages,
      previousPage: Math.max(1, page - 1),
      nextPage: Math.min(totalPages || 1, page + 1),
      hasPrevious: page > 1,
      hasNext: totalPages > 0 && page < totalPages,
      items: items
    };
  }

  function savedNameKey(name) {
    name = name || {};
    return (
      String(name.first_name || name.name || '')
        .trim()
        .toLowerCase() +
      '::' +
      normalizeGenderKey(name.gender)
    );
  }

  /**
   * Match a result-card name against a shortlist entry.
   * Prefer first_name + gender when both have gender; otherwise first_name only
   * (generator / getMyBabyNames often omit or use F/M).
   */
  function isSameSavedName(a, b) {
    a = a || {};
    b = b || {};
    var aFirst = String(a.first_name || a.name || '')
      .trim()
      .toLowerCase();
    var bFirst = String(b.first_name || b.name || '')
      .trim()
      .toLowerCase();
    if (!aFirst || aFirst !== bFirst) return false;
    var aGender = normalizeGenderKey(a.gender);
    var bGender = normalizeGenderKey(b.gender);
    if (!aGender || !bGender) return true;
    return aGender === bGender;
  }

  function hasCookie(doc, name) {
    if (!doc || !name) return false;
    return String(doc.cookie || '')
      .split(';')
      .some(function (cookie) {
        return cookie.trim().indexOf(name + '=') === 0;
      });
  }

  function normalizeSavedPayload(response) {
    if (!response) return null;
    if (response.result && response.result !== 'success') return null;
    var data = response.data || response;
    if (!data || !Array.isArray(data.baby_names)) return null;
    return {
      last_name: data.last_name || '',
      baby_names: data.baby_names.map(function (item) {
        item = item || {};
        return Object.assign({}, item, {
          first_name: String(item.first_name || item.name || '').trim(),
          gender: normalizeGenderKey(item.gender)
        });
      }),
      status: data.status || 'loaded'
    };
  }

  function errorText(error) {
    return [
      error && error.message,
      error && error.msg,
      error && error.error,
      error && error.reason,
      error && error.data && error.data.message,
      error && error.data && error.data.reason
    ]
      .filter(Boolean)
      .join(' ');
  }

  function isAuthFailure(error) {
    var status = Number(
      error &&
        (error.status ||
          error.statusCode ||
          (error.response && error.response.status))
    );
    return (
      status === 401 ||
      status === 403 ||
      /401|403|unauthor|token|login|session expired/i.test(errorText(error))
    );
  }

  function getFailureMessage(error, fallback, labels) {
    labels = mergeLabels(labels);
    var text = errorText(error).toLowerCase();
    if (isAuthFailure(error)) return labels.msgSessionExpired;
    if (/full|limit|maximum|max/.test(text)) return labels.msgShortlistFull;
    return fallback;
  }

  function boot(doc) {
    if (
      !browserRoot ||
      !doc ||
      !browserRoot.customElements ||
      browserRoot.customElements.get('baby-name-list')
    )
      return;

    class BabyNameList extends browserRoot.HTMLElement {
      constructor() {
        super();
        this.names = [];
        this.route = null;
        this.state = {
          popularity: null,
          sorting: null,
          page: 1,
          pageSize: RESULTS_PAGE_SIZE,
          total: 0
        };
        this.saved = { last_name: '', baby_names: [], status: 'init' };
        this.pendingNames = new Set();
        this.requestSequence = 0;
        this.savedRequestSequence = 0;
        this.abortController = null;
        this.resultAbortController = null;
        this.savedAbortController = null;
        this.labels = mergeLabels();
        this.connected = false;
      }

      connectedCallback() {
        if (this.connected) return;
        this.connected = true;
        this.abortController = new browserRoot.AbortController();
        this.cacheElements();
        this.labels = parseLabelsFromRoot(this);
        this.addEventListener('change', this.onChange, {
          signal: this.abortController.signal
        });
        this.addEventListener('click', this.onClick, {
          signal: this.abortController.signal
        });
        this.addEventListener('keydown', this.onKeyDown, {
          signal: this.abortController.signal
        });
        this.addEventListener('focusout', this.onFocusOut, {
          signal: this.abortController.signal
        });
        doc.addEventListener('click', this.onDocumentClick, {
          signal: this.abortController.signal
        });
        doc.addEventListener('baby-names:route-change', this.onRouteChange, {
          signal: this.abortController.signal
        });
        if (this.shortlistDialog) {
          this.shortlistDialog.addEventListener(
            'baby-name:dialog:close',
            this.onShortlistClose,
            { signal: this.abortController.signal }
          );
        }
        this.syncLoginState();
        this.loadSavedNames(false);
        var flow = browserRoot.MomcozyBabyNameFlow;
        if (flow && typeof flow.parseRoute === 'function') {
          this.applyRoute(flow.parseRoute(browserRoot.location.search));
        }
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.resultAbortController) this.resultAbortController.abort();
        if (this.savedAbortController) this.savedAbortController.abort();
        if (this.toastTimer) {
          browserRoot.clearTimeout(this.toastTimer);
          this.toastTimer = null;
        }
        this.connected = false;
      }

      cacheElements() {
        this.grid = this.querySelector('[data-baby-name-grid]');
        this.resultsBody = this.querySelector('[data-baby-name-results-body]');
        this.pagination = this.querySelector('[data-baby-name-pagination]');
        this.status = this.querySelector('[data-baby-name-status]');
        this.emptyState = this.querySelector('[data-baby-name-empty]');
        this.resultsTitle = this.querySelector(
          '[data-baby-name-results-title]'
        );
        this.cardTemplate = this.querySelector(
          '[data-baby-name-card-template]'
        );
        this.arrowTemplate = this.querySelector(
          '[data-baby-name-arrow-template]'
        );
        this.savedTemplate = this.querySelector(
          '[data-baby-name-saved-template]'
        );
        this.savedList = this.querySelector('[data-baby-name-saved-list]');
        this.savedStatus = this.querySelector('[data-baby-name-saved-status]');
        this.savedViewport = this.querySelector(
          '[data-baby-name-saved-viewport]'
        );
        this.savedLoading = this.querySelector(
          '[data-baby-name-saved-loading]'
        );
        this.savedEmpty = this.querySelector('[data-baby-name-saved-empty]');
        this.savedError = this.querySelector('[data-baby-name-saved-error]');
        this.savedErrorMessage = this.querySelector(
          '[data-baby-name-saved-error-message]'
        );
        this.shortlistButton = this.querySelector(
          '[data-baby-name-shortlist-open]'
        );
        this.shortlistCountNodes = this.querySelectorAll(
          '[data-baby-name-shortlist-count]'
        );
        this.dropdowns = this.querySelectorAll('[data-baby-name-dropdown]');
        this.dialogId = this.getAttribute('data-shortlist-dialog-id');
        this.shortlistDialog = this.querySelector(
          '[data-yg-bn-dialog="' + this.dialogId + '"]'
        );
        this.toast = this.querySelector('[data-baby-name-toast]');
        this.toastText = this.querySelector('[data-baby-name-toast-text]');
        this.toastTimer = null;
      }

      onRouteChange = (event) => {
        this.applyRoute(event.detail && event.detail.route);
      };

      onShortlistClose = () => {
        this.savedRequestSequence += 1;
        if (this.savedAbortController) this.savedAbortController.abort();
        this.savedAbortController = null;
        this.setSavedLoading(false);
      };

      onChange = (event) => {
        var filter = event.target.closest('[data-baby-name-filter]');
        var sorting = event.target.closest('[data-baby-name-sorting]');
        if (!filter && !sorting) return;
        this.syncDropdown(event.target);
        this.dispatchResultsChange({
          popularity: filter
            ? filter.value
            : this.route && this.route.popularity,
          sort: sorting ? sorting.value : this.route && this.route.sort,
          page: 1
        });
      };

      onClick = (event) => {
        var dropdownOption = event.target.closest(
          '[data-baby-name-dropdown-option]'
        );
        if (dropdownOption) {
          this.selectDropdownOption(dropdownOption);
          return;
        }

        var dropdownToggle = event.target.closest(
          '[data-baby-name-dropdown-toggle]'
        );
        if (dropdownToggle) {
          this.toggleDropdown(dropdownToggle);
          return;
        }

        var pageButton = event.target.closest('[data-baby-name-page]');
        if (pageButton && !pageButton.disabled) {
          this.dispatchResultsChange({
            page: Number(pageButton.getAttribute('data-baby-name-page'))
          });
          return;
        }

        var resultsRetry = event.target.closest(
          '[data-baby-name-results-retry]'
        );
        if (resultsRetry) {
          this.setButtonLoading(resultsRetry, true);
          Promise.resolve(this.loadResults(true)).finally(() => {
            this.setButtonLoading(resultsRetry, false);
          });
          return;
        }

        var detailButton = event.target.closest('[data-baby-name-detail]');
        if (detailButton) {
          var card = detailButton.closest('[data-baby-name-id]');
          var selected = this.findMockName(card);
          if (selected) {
            var cardGender = card && card.getAttribute('data-gender');
            if (cardGender && !normalizeGenderKey(selected.gender)) {
              selected = Object.assign({}, selected, { gender: cardGender });
            }
            this.dispatchEvent(
              new browserRoot.CustomEvent('baby-names:select', {
                bubbles: true,
                detail: { returnView: 'results', name: selected }
              })
            );
          }
          return;
        }

        var favoriteButton = event.target.closest('[data-baby-name-favorite]');
        if (favoriteButton) {
          var favorite = this.findMockName(
            favoriteButton.closest('[data-baby-name-id]')
          );
          if (favorite) this.toggleFavorite(favorite, favoriteButton);
          return;
        }

        if (event.target.closest('[data-baby-name-shortlist-open]')) {
          this.openShortlist();
          return;
        }

        if (event.target.closest('[data-baby-name-saved-retry]')) {
          this.loadSavedNames(true);
          return;
        }

        var removeButton = event.target.closest(
          '[data-baby-name-saved-remove]'
        );
        if (removeButton) {
          this.removeSavedName(
            removeButton.getAttribute('data-baby-name-saved-remove'),
            removeButton
          );
          return;
        }
      };

      onKeyDown = (event) => {
        var dropdown = event.target.closest('[data-baby-name-dropdown]');
        if (!dropdown) return;

        if (event.key === 'Escape') {
          this.closeDropdowns();
          var toggle = dropdown.querySelector(
            '[data-baby-name-dropdown-toggle]'
          );
          if (toggle) toggle.focus();
          return;
        }

        var option = event.target.closest('[data-baby-name-dropdown-option]');
        if (!option || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp'))
          return;
        event.preventDefault();
        var options = Array.from(
          dropdown.querySelectorAll('[data-baby-name-dropdown-option]')
        );
        var index = options.indexOf(option);
        var direction = event.key === 'ArrowDown' ? 1 : -1;
        options[(index + direction + options.length) % options.length].focus();
      };

      onDocumentClick = (event) => {
        // Close when clicking outside any open dropdown (including other
        // controls inside this section, e.g. Email / cards).
        if (!event.target.closest('[data-baby-name-dropdown]')) {
          this.closeDropdowns();
        }
      };

      onFocusOut = (event) => {
        var dropdown = event.target.closest('[data-baby-name-dropdown]');
        if (!dropdown || !dropdown.classList.contains('is-open')) return;
        var next = event.relatedTarget;
        // Keep open while focus moves between toggle / options inside the same dropdown.
        if (next && dropdown.contains(next)) return;
        dropdown.classList.remove('is-open');
        var toggle = dropdown.querySelector('[data-baby-name-dropdown-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      };

      dispatchResultsChange(detail) {
        this.dispatchEvent(
          new browserRoot.CustomEvent('baby-names:results-change', {
            bubbles: true,
            detail: detail || {}
          })
        );
      }

      applyRoute(nextRoute) {
        if (!nextRoute || nextRoute.view !== 'results') {
          if (this.resultAbortController) this.resultAbortController.abort();
          this.route = null;
          this.clearInitializingState();
          return;
        }
        this.route = Object.assign({}, nextRoute);
        this.state.page = nextRoute.page || 1;
        this.state.pageSize = RESULTS_PAGE_SIZE;
        this.state.popularity = normalizePopularity(nextRoute.popularity);
        this.state.sorting = nextRoute.sort || null;
        var filter = this.querySelector('[data-baby-name-filter]');
        var sorting = this.querySelector('[data-baby-name-sorting]');
        if (filter) {
          filter.value = nextRoute.popularity || 'all';
          this.syncDropdown(filter);
        }
        if (sorting) {
          sorting.value = nextRoute.sort || '';
          this.syncDropdown(sorting);
        }
        this.loadResults();
      }

      toggleDropdown(toggle) {
        var dropdown = toggle.closest('[data-baby-name-dropdown]');
        if (!dropdown) return;
        var shouldOpen = !dropdown.classList.contains('is-open');
        this.closeDropdowns(dropdown);
        dropdown.classList.toggle('is-open', shouldOpen);
        toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      }

      closeDropdowns(except) {
        Array.from(this.dropdowns || []).forEach(function (dropdown) {
          if (dropdown === except) return;
          dropdown.classList.remove('is-open');
          var toggle = dropdown.querySelector(
            '[data-baby-name-dropdown-toggle]'
          );
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      }

      selectDropdownOption(option) {
        var dropdown = option.closest('[data-baby-name-dropdown]');
        if (!dropdown) return;
        var select = dropdown.querySelector('select');
        if (!select) return;
        select.value = option.getAttribute('data-value') || '';
        this.syncDropdown(select);
        dropdown.classList.remove('is-open');
        var toggle = dropdown.querySelector('[data-baby-name-dropdown-toggle]');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.focus();
        }
        select.dispatchEvent(
          new browserRoot.Event('change', { bubbles: true })
        );
      }

      syncDropdown(select) {
        if (!select) return;
        var dropdown = select.closest('[data-baby-name-dropdown]');
        if (!dropdown) return;
        var selected = select.options[select.selectedIndex];
        var valueNode = dropdown.querySelector(
          '[data-baby-name-dropdown-value]'
        );
        if (valueNode && selected) valueNode.textContent = selected.textContent;
        dropdown
          .querySelectorAll('[data-baby-name-dropdown-option]')
          .forEach(function (option) {
            option.setAttribute(
              'aria-selected',
              option.getAttribute('data-value') === select.value
                ? 'true'
                : 'false'
            );
          });
      }

      findMockName(card) {
        if (!card) return null;
        var id = card.getAttribute('data-baby-name-id');
        return (
          this.names.find(function (name) {
            return String(name.id) === String(id);
          }) || null
        );
      }

      setStatus(message, kind) {
        if (this.emptyState) {
          this.emptyState.hidden = kind !== 'empty' || !message;
        }
        if (!this.status) return;
        if (kind === 'empty') {
          this.status.hidden = true;
          this.status.textContent = '';
          this.status.replaceChildren();
          return;
        }
        this.status.textContent = message || '';
        this.status.hidden = !message;
        this.status.setAttribute('data-state', kind || 'info');
        this.status.replaceChildren();
        if (message) {
          this.status.appendChild(doc.createTextNode(message));
        }
        if (message && kind === 'error') {
          var retry = doc.createElement('button');
          retry.type = 'button';
          retry.textContent = this.labels.retryLabel;
          retry.setAttribute('data-baby-name-results-retry', '');
          this.status.appendChild(doc.createTextNode(' '));
          this.status.appendChild(retry);
        }
      }

      /**
       * Fixed top toast for shortlist favorite feedback (generator-aligned).
       * Does not use the list status banner above the result grid.
       */
      showToast(message, type) {
        if (!this.toast || !this.toastText || !message) return;
        if (this.toastTimer) {
          browserRoot.clearTimeout(this.toastTimer);
          this.toastTimer = null;
        }
        this.toastText.textContent = message;
        this.toast.classList.remove('is-success', 'is-error', 'is-visible');
        this.toast.classList.add(type === 'error' ? 'is-error' : 'is-success');
        // Force reflow so re-opening the same message still animates.
        void this.toast.offsetWidth;
        this.toast.classList.add('is-visible');
        this.toastTimer = browserRoot.setTimeout(() => {
          this.toast.classList.remove('is-visible');
          this.toastTimer = null;
        }, 5000);
      }

      getUI() {
        return browserRoot.MomcozyBabyNameUI || null;
      }

      showLoadingOverlay() {
        var target = this.resultsBody || this.grid;
        var ui = this.getUI();
        if (ui && typeof ui.setDataLoading === 'function' && target) {
          ui.setDataLoading(target, true);
        } else if (this.grid) {
          this.grid.setAttribute('aria-busy', 'true');
        }
        if (this.pagination) {
          this.pagination.classList.add('is-loading');
          this.pagination.setAttribute('aria-disabled', 'true');
        }
      }

      hideLoadingOverlay() {
        var target = this.resultsBody || this.grid;
        var ui = this.getUI();
        if (ui && typeof ui.setDataLoading === 'function' && target) {
          ui.setDataLoading(target, false);
        } else if (this.grid) {
          this.grid.removeAttribute('aria-busy');
        }
        if (this.pagination) {
          this.pagination.classList.remove('is-loading');
          this.pagination.removeAttribute('aria-disabled');
        }
        this.clearInitializingState();
      }

      clearInitializingState() {
        this.classList.remove('is-initializing');
        this.removeAttribute('aria-busy');
      }

      setButtonLoading(element, loading) {
        var ui = this.getUI();
        if (ui && typeof ui.setButtonLoading === 'function') {
          ui.setButtonLoading(element, loading);
          return;
        }
        if (!element) return;
        element.classList.toggle('is-loading', Boolean(loading));
        if (loading) {
          element.setAttribute('aria-busy', 'true');
          element.disabled = true;
        } else {
          element.removeAttribute('aria-busy');
        }
      }

      updateResultsTitle(total, route) {
        if (!this.resultsTitle) return;
        this.resultsTitle.innerHTML = buildResultsTitleHtml(
          total,
          route || this.route,
          this.labels
        );
      }

      clearStaleResults() {
        this.names = [];
        this.state.total = 0;
        this.updateResultsTitle(0, this.route);
        this.renderResults([]);
        this.renderPagination();
        this.setStatus('', '');
      }

      async loadResults(shouldFocus) {
        if (!this.route || this.route.view !== 'results') return;
        var sequence = ++this.requestSequence;
        if (this.resultAbortController) this.resultAbortController.abort();
        this.resultAbortController = new browserRoot.AbortController();
        var client = browserRoot.MomcozyBabyNameRequest;
        var payload = buildResultsPayload(this.route);
        // Loading overlay covers the full results body, including the empty state.
        this.setAttribute('aria-busy', 'true');
        this.showLoadingOverlay();
        try {
          if (!client || typeof client.generateNames !== 'function')
            throw new Error('Generator client is unavailable');
          var response = normalizeResultsResponse(
            await client.generateNames(payload, {
              signal: this.resultAbortController.signal
            }),
            payload
          );
          if (sequence !== this.requestSequence) return;
          this.names = response.names;
          this.state.page = response.page;
          this.state.total = response.total;
          this.updateResultsTitle(response.total, this.route);
          this.renderResults(response.names);
          this.renderPagination();
          this.setStatus(
            response.names.length ? '' : this.labels.emptyMessage,
            'empty'
          );
          if (shouldFocus && this.grid)
            this.grid.focus({ preventScroll: true });
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          if (sequence === this.requestSequence) {
            // Never keep previous cards/pagination as if they match the new filters.
            this.clearStaleResults();
            this.setStatus(this.labels.msgLoadError, 'error');
          }
        } finally {
          if (sequence === this.requestSequence) {
            this.hideLoadingOverlay();
          }
        }
      }

      renderResults(names) {
        if (!this.grid || !this.cardTemplate) return;
        this.grid.replaceChildren();
        var fragment = doc.createDocumentFragment();
        names.forEach((name) => {
          var presentation = getCardPresentation(name, this.labels);
          var card =
            this.cardTemplate.content.firstElementChild.cloneNode(true);
          card.setAttribute('data-baby-name-id', name.id);
          card.setAttribute('data-gender', name.gender || '');
          card.querySelector('[data-name]').textContent = name.first_name;
          var gender = card.querySelector('[data-gender]');
          gender.textContent = presentation.genderLabel;
          gender.setAttribute('data-gender-value', name.gender);
          gender.hidden = !presentation.genderLabel;
          var meaning = card.querySelector('[data-meaning]');
          meaning.textContent = presentation.meaningLabel;
          meaning.parentElement.hidden = !presentation.meaningLabel;
          var origin = card.querySelector('[data-origin]');
          origin.textContent = presentation.originLabel;
          origin.parentElement.hidden = !presentation.originLabel;
          card.querySelector('[data-rank]').textContent =
            presentation.rankLabel;
          var popularityBar = card.querySelector('[data-popularity-bar]');
          popularityBar.parentElement.hidden = presentation.popularity === null;
          if (presentation.popularity !== null) {
            popularityBar.style.setProperty(
              '--yg-bn-popularity',
              presentation.popularity + '%'
            );
          }
          this.syncFavoriteButton(
            card.querySelector('[data-baby-name-favorite]'),
            name
          );
          fragment.appendChild(card);
        });
        this.grid.appendChild(fragment);
      }

      renderPagination() {
        if (!this.pagination || !this.arrowTemplate) return;
        this.pagination.replaceChildren();
        var pager = getPagerState(
          this.state.page,
          this.state.total,
          this.state.pageSize
        );
        if (pager.totalPages <= 1) {
          this.pagination.hidden = true;
          return;
        }
        this.pagination.hidden = false;
        var fragment = doc.createDocumentFragment();
        fragment.appendChild(
          this.createArrow('previous', pager.previousPage, !pager.hasPrevious)
        );
        pager.items.forEach((item) => {
          if (item.type === 'ellipsis') {
            var ellipsis = doc.createElement('span');
            ellipsis.className = 'yg-bn-list__ellipsis';
            ellipsis.setAttribute('aria-hidden', 'true');
            ellipsis.textContent = '...';
            fragment.appendChild(ellipsis);
            return;
          }
          fragment.appendChild(
            this.createPageButton(item.page, item.page === pager.page)
          );
        });
        fragment.appendChild(
          this.createArrow('next', pager.nextPage, !pager.hasNext)
        );
        this.pagination.appendChild(fragment);
      }

      createPageButton(page, isActive) {
        var button = doc.createElement('button');
        button.type = 'button';
        button.className = 'yg-bn-list__page' + (isActive ? ' is-active' : '');
        button.textContent = String(page);
        button.setAttribute('data-baby-name-page', page);
        button.setAttribute(
          'aria-label',
          applyLabelTemplate(this.labels.ariaPage, { page: page })
        );
        if (isActive) button.setAttribute('aria-current', 'page');
        button.disabled = !!isActive;
        button.setAttribute('aria-disabled', isActive ? 'true' : 'false');
        return button;
      }

      createArrow(direction, page, disabled) {
        var button =
          this.arrowTemplate.content.firstElementChild.cloneNode(true);
        button.setAttribute('data-baby-name-page', page);
        button.setAttribute(
          'aria-label',
          direction === 'previous'
            ? this.labels.ariaPrevPage
            : this.labels.ariaNextPage
        );
        button.classList.add(
          'yg-bn-list__page--arrow',
          'yg-bn-list__page--' + direction
        );
        // Template arrow SVG points right; flip previous for left chevron.
        button
          .querySelector('svg')
          .classList.toggle('is-prev', direction === 'previous');
        button.disabled = disabled;
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        return button;
      }

      loginCookieName() {
        return (
          (browserRoot.__MC__CONFIG__ &&
            browserRoot.__MC__CONFIG__.cookieName) ||
          'momcozy-token'
        );
      }

      isLoggedIn() {
        if (
          browserRoot.MomcozyBabyNameFlow &&
          typeof browserRoot.MomcozyBabyNameFlow.isLoggedIn === 'function'
        ) {
          return browserRoot.MomcozyBabyNameFlow.isLoggedIn();
        }
        if (
          browserRoot.MomcozyBabyNameRequest &&
          typeof browserRoot.MomcozyBabyNameRequest.hasAuthToken === 'function'
        ) {
          return browserRoot.MomcozyBabyNameRequest.hasAuthToken(
            browserRoot,
            doc
          );
        }
        return hasCookie(doc, this.loginCookieName());
      }

      requestLogin(trigger) {
        var focusTarget =
          trigger ||
          (doc.activeElement &&
            doc.activeElement.closest &&
            doc.activeElement.closest('[data-baby-name-favorite]'));
        if (focusTarget && typeof focusTarget.blur === 'function') {
          focusTarget.blur();
        }
        this.dispatchEvent(
          new browserRoot.CustomEvent('baby-names:login-required', {
            bubbles: true
          })
        );
      }

      syncLoginState() {
        if (this.shortlistButton) this.shortlistButton.hidden = false;
      }

      savedMatch(name) {
        return (
          this.saved.baby_names.find(function (savedName) {
            return isSameSavedName(savedName, name);
          }) || null
        );
      }

      syncFavoriteButton(button, name) {
        if (!button) return;
        var isSaved = Boolean(this.savedMatch(name));
        button.classList.toggle('is-saved', isSaved);
        button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
        button.setAttribute(
          'aria-label',
          applyLabelTemplate(
            isSaved ? this.labels.ariaRemoveFrom : this.labels.ariaSaveTo,
            { name: name.first_name }
          )
        );
        button.disabled = this.pendingNames.has(savedNameKey(name));
        // Force filled/outline on the path so activation is visible even if
        // SVG presentation attributes or theme CSS fight the class styles.
        var heartPath = button.querySelector('.yg-bn-list__heart path');
        if (heartPath) {
          if (isSaved) {
            heartPath.setAttribute('fill', 'currentColor');
            heartPath.setAttribute('stroke', 'none');
          } else {
            heartPath.setAttribute('fill', 'none');
            heartPath.setAttribute('stroke', 'currentColor');
            heartPath.setAttribute('stroke-width', '1.5');
            heartPath.setAttribute('stroke-linejoin', 'round');
          }
        }
      }

      syncAllFavoriteButtons() {
        this.querySelectorAll('[data-baby-name-id]').forEach((card) => {
          var name = this.findMockName(card);
          if (name)
            this.syncFavoriteButton(
              card.querySelector('[data-baby-name-favorite]'),
              name
            );
        });
      }

      syncSavedState(options) {
        options = options || {};
        this.shortlistCountNodes.forEach((node) => {
          node.textContent = String(this.saved.baby_names.length);
        });
        this.syncAllFavoriteButtons();
        if (!options.skipRender) this.renderSavedNames();
        browserRoot.ygMyBabyNamesList = {
          last_name: this.saved.last_name,
          baby_names: this.saved.baby_names.slice(),
          status: 'loaded'
        };
      }

      async loadSavedNames(force) {
        if (!this.isLoggedIn()) return;
        var globalPayload = normalizeSavedPayload(
          browserRoot.ygMyBabyNamesList
        );
        if (!force && globalPayload && globalPayload.status !== 'init') {
          this.saved = globalPayload;
          this.syncSavedState();
          return;
        }
        var client = browserRoot.MomcozyBabyNameRequest;
        if (!client || typeof client.getMyBabyNames !== 'function') {
          this.showSavedError(this.labels.msgShortlistUnavailable);
          return;
        }

        var sequence = ++this.savedRequestSequence;
        if (this.savedAbortController) this.savedAbortController.abort();
        this.savedAbortController =
          typeof browserRoot.AbortController === 'function'
            ? new browserRoot.AbortController()
            : null;
        var signal =
          this.savedAbortController && this.savedAbortController.signal;

        this.setSavedLoading(true);
        try {
          var payload = normalizeSavedPayload(
            await client.getMyBabyNames(signal ? { signal: signal } : undefined)
          );
          if (sequence !== this.savedRequestSequence) return;
          if (!payload) throw new Error('Unable to load Shortlist');
          this.saved = payload;
          this.syncSavedState();
          this.setSavedStatus('', 'info');
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          if (sequence !== this.savedRequestSequence) return;
          if (isAuthFailure(error)) {
            if (browserRoot.YgBabyNameDialog)
              browserRoot.YgBabyNameDialog.close(this.dialogId);
            this.requestLogin();
            return;
          }
          this.showSavedError(
            getFailureMessage(error, this.labels.shortlistError, this.labels)
          );
        } finally {
          if (sequence !== this.savedRequestSequence) return;
          this.setSavedLoading(false);
        }
      }

      async openShortlist() {
        if (!this.isLoggedIn()) {
          this.requestLogin(
            this.querySelector('[data-baby-name-shortlist-open]')
          );
          return;
        }
        if (browserRoot.YgBabyNameDialog) browserRoot.YgBabyNameDialog.open(this.dialogId);
        await this.loadSavedNames(true);
      }

      async toggleFavorite(name, button) {
        if (!this.isLoggedIn()) {
          this.requestLogin(button);
          return;
        }
        var key = savedNameKey(name);
        if (this.pendingNames.has(key)) return;
        var existing = this.savedMatch(name);
        if (existing) return this.removeSavedName(existing.id, button, name);

        var client = browserRoot.MomcozyBabyNameRequest;
        if (!client || typeof client.addMyBabyName !== 'function') {
          this.showToast(this.labels.msgShortlistUnavailable, 'error');
          return;
        }
        this.pendingNames.add(key);
        this.setButtonLoading(button, true);
        this.syncFavoriteButton(button, name);
        try {
          var favoritePayload = {
            baby_name: {
              first_name: name.first_name,
              gender: name.gender,
              location: name.location
            }
          };
          var response = await client.addMyBabyName(favoritePayload);
          if (!response || (response.result && response.result !== 'success'))
            throw response || new Error('Unable to save name');
          var savedPayload = normalizeSavedPayload(response);
          var returned =
            response.data && (response.data.baby_name || response.data);
          if (savedPayload) {
            this.saved = savedPayload;
          } else if (returned && returned.id) {
            // Keep card gender (girl/boy); API may return F/M and would break match.
            this.saved.baby_names.push(
              Object.assign({}, name, returned, {
                first_name: name.first_name,
                gender: normalizeGenderKey(name.gender || returned.gender)
              })
            );
          } else {
            var refreshedPayload = normalizeSavedPayload(
              await client.getMyBabyNames()
            );
            if (!refreshedPayload)
              throw new Error('Saved name ID was not returned');
            this.saved = refreshedPayload;
          }
          this.showToast(
            applyLabelTemplate(this.labels.msgSavedToast, {
              name: name.first_name
            })
          );
        } catch (error) {
          if (isAuthFailure(error)) {
            this.requestLogin();
            return;
          }
          this.showToast(
            getFailureMessage(error, this.labels.msgSaveError, this.labels),
            'error'
          );
        } finally {
          this.pendingNames.delete(key);
          this.setButtonLoading(button, false);
          this.syncSavedState();
        }
      }

      async removeSavedName(savedId, button, mockName) {
        var existing = this.saved.baby_names.find(function (name) {
          return String(name.id) === String(savedId);
        });
        if (!existing) return;
        var key = savedNameKey(existing);
        if (this.pendingNames.has(key)) return;
        var client = browserRoot.MomcozyBabyNameRequest;
        if (!client || typeof client.deleteMyBabyName !== 'function') {
          this.showToast(this.labels.msgShortlistUnavailable, 'error');
          return;
        }
        this.pendingNames.add(key);
        this.setButtonLoading(button, true);
        try {
          var response = await client.deleteMyBabyName(existing.id);
          if (!response || (response.result && response.result !== 'success'))
            throw response || new Error('Unable to remove name');
          this.saved.baby_names = this.saved.baby_names.filter(function (name) {
            return String(name.id) !== String(existing.id);
          });
          this.removeSavedRowElement(existing.id);
          if (!this.saved.baby_names.length) this.showSavedEmpty(true);
          this.showToast(
            applyLabelTemplate(this.labels.msgRemovedToast, {
              name: existing.first_name
            })
          );
        } catch (error) {
          if (isAuthFailure(error)) {
            if (browserRoot.YgBabyNameDialog)
              browserRoot.YgBabyNameDialog.close(this.dialogId);
            this.requestLogin();
            return;
          }
          this.showToast(
            getFailureMessage(error, this.labels.msgRemoveError, this.labels),
            'error'
          );
        } finally {
          this.pendingNames.delete(key);
          if (button && button.isConnected)
            this.setButtonLoading(button, false);
          this.syncSavedState({ skipRender: true });
          if (mockName) this.syncFavoriteButton(button, mockName);
        }
      }

      removeSavedRowElement(savedId) {
        if (!this.savedList) return;
        var removeButton = this.savedList.querySelector(
          '[data-baby-name-saved-remove="' + savedId + '"]'
        );
        if (!removeButton) return;
        var row = removeButton.closest('.yg-bn-list__saved-row');
        if (row) row.remove();
      }

      setSavedStatus(message, kind) {
        if (!this.savedStatus) return;
        this.savedStatus.textContent = message || '';
        this.savedStatus.hidden = !message;
        this.savedStatus.setAttribute('data-state', kind || 'info');
      }

      setSavedLoading(loading) {
        if (this.savedLoading) this.savedLoading.hidden = !loading;
        if (this.savedViewport) {
          if (loading) {
            this.savedViewport.setAttribute('aria-busy', 'true');
          } else {
            this.savedViewport.removeAttribute('aria-busy');
          }
        }
        if (!loading) return;
        if (this.savedList) this.savedList.hidden = true;
        if (this.savedEmpty) this.savedEmpty.hidden = true;
        if (this.savedError) this.savedError.hidden = true;
        this.setSavedStatus('', 'info');
      }

      showSavedEmpty(show) {
        if (this.savedEmpty) this.savedEmpty.hidden = !show;
        if (this.savedList) this.savedList.hidden = show;
        if (show && this.savedError) this.savedError.hidden = true;
      }

      showSavedError(message) {
        if (!this.savedError) {
          this.setSavedStatus(message, 'error');
          return;
        }
        if (this.savedErrorMessage && message)
          this.savedErrorMessage.textContent = message;
        this.savedError.hidden = !message;
        if (this.savedList) this.savedList.hidden = Boolean(message);
        if (this.savedEmpty) this.savedEmpty.hidden = true;
        if (message) this.setSavedStatus('', 'info');
      }

      renderSavedNames() {
        if (!this.savedList || !this.savedTemplate) return;
        var scrollTop = this.savedViewport ? this.savedViewport.scrollTop : 0;
        this.showSavedError('');
        if (!this.saved.baby_names.length) {
          this.savedList.replaceChildren();
          this.showSavedEmpty(true);
          return;
        }
        this.showSavedEmpty(false);
        var fragment = doc.createDocumentFragment();
        this.saved.baby_names.forEach((name) => {
          var row =
            this.savedTemplate.content.firstElementChild.cloneNode(true);
          row.querySelector('[data-saved-name]').textContent = name.first_name;
          row
            .querySelector('[data-saved-remove]')
            .setAttribute('data-baby-name-saved-remove', name.id);
          row.querySelector('[data-saved-remove]').setAttribute(
            'aria-label',
            applyLabelTemplate(this.labels.ariaRemoveFrom, {
              name: name.first_name
            })
          );
          fragment.appendChild(row);
        });
        this.savedList.replaceChildren(fragment);
        this.savedList.hidden = false;
        if (this.savedViewport) this.savedViewport.scrollTop = scrollTop;
      }
    }

    browserRoot.customElements.define('baby-name-list', BabyNameList);
  }

  return {
    MOBILE_BREAKPOINT: MOBILE_BREAKPOINT,
    RANK_BAR_BASE: RANK_BAR_BASE,
    RANK_BAR_MIN_PCT: RANK_BAR_MIN_PCT,
    DEFAULT_RANK_YEAR: DEFAULT_RANK_YEAR,
    createMockNames: createMockNames,
    queryMockNames: queryMockNames,
    getPageSize: getPageSize,
    getPagerState: getPagerState,
    getCardPresentation: getCardPresentation,
    rankToBarPercent: rankToBarPercent,
    buildResultsTitle: buildResultsTitle,
    buildResultsTitleHtml: buildResultsTitleHtml,
    applyLabelTemplate: applyLabelTemplate,
    mergeLabels: mergeLabels,
    DEFAULT_LABELS: DEFAULT_LABELS,
    escapeHtml: escapeHtml,
    savedNameKey: savedNameKey,
    isSameSavedName: isSameSavedName,
    normalizeGenderKey: normalizeGenderKey,
    isAuthFailure: isAuthFailure,
    normalizeSavedPayload: normalizeSavedPayload,
    buildResultsPayload: buildResultsPayload,
    normalizeResultsResponse: normalizeResultsResponse,
    boot: boot
  };
});
